var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",staticStyle:{"display":"flex"},style:({
        backgroundColor: _vm.lighterColor,
        'justify-content': _vm.invert ? 'end' : 'left',
    })},[_c('div',{staticClass:"progress",class:{ animate: _vm.animate },style:({ width: _vm.progress + '%', backgroundColor: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }